const loadHighcharts = (function Highcharts() {
	const State = {
		Initial: 1,
		Loading: 2,
		Finished: 3,
	}
	
	let currentState = State.Initial;
	let callbacks = [];

	const highcharts = 'https://code.highcharts.com/highcharts.js';
	let modules = [
		'https://code.highcharts.com/modules/accessibility.js',
	];

	function loadHighcharts(callback) {
		if (currentState === State.Finished) {
			return callback();
		}

		callbacks.push(callback);

		if (currentState === State.Initial) {
			const script = document.createElement('script');
			script.defer = true;
			script.onload = () => {
				loadModules();
			}

			script.src = highcharts;
			document.body.appendChild(script);

			currentState = State.Loading;
		}
	}

	function loadModules() {
		console.log('loading modules')
		modules.forEach(source => {
			const script = document.createElement('script');
			script.defer = true;
			script.onload = () => {
				modules = modules.filter(mod => mod !== source);

				if (modules.length === 0) {
					currentState = State.Finished;

					callbacks.forEach((callback) => {
						callback();
					})
				}
			}

			script.src = source;
			document.body.appendChild(script);
		})
	}

	return loadHighcharts;
})();
